/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class incomerevenuejournal extends IceEntity {
	income_revenue_journal_key: string = "";
  medical_service_key: string = "";
  service_payment_reference_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  last_name: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  src_key: string = "";
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  journal_date: any = NaN;
  journal_desc: string = "";
  journal_code: string = "";
  journal_note: string  = "";
  cosmetic_option: boolean = false;
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  debit: number = 0.0;
  credit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accounting_period_key: string = "";
  entry_type: IceTypes.journal_entry_type.jetGeneral;

  constructor(copy?: incomerevenuejournal) {
    super();

    if (copy != null) {
      this.income_revenue_journal_key = copy.income_revenue_journal_key;
      this.medical_service_key = copy.medical_service_key;
      this.service_payment_reference_key = copy.service_payment_reference_key;
      this.trans_account = copy.trans_account;
      this.account_type = copy.account_type;
      this.last_name = copy.last_name;
      this.subscriber_key = copy.subscriber_key;
      this.src_key = copy.src_key;
      this.src_type = copy.src_type;
      this.coa_type = copy.coa_type;
      this.journal_date = copy.journal_date;
      this.journal_desc = copy.journal_desc;
      this.journal_code = copy.journal_code;
      this.journal_note = copy.journal_note;
      this.cosmetic_option = copy.cosmetic_option;
      this.tax_status = copy.tax_status;
      this.debit = copy.debit;
      this.credit = copy.credit;
      this.record_version = copy.record_version;
      this.offline_record_status = copy.offline_record_status;
      this.accounting_period_key = copy.accounting_period_key;
      this.entry_type = copy.entry_type;
    }
  }

  gettablename(): string {
    return "INCOME_REVENUE_JOURNAL";
  }
}
